import { render, staticRenderFns } from "./SettingMessageTemplates.vue?vue&type=template&id=28c7e952"
import script from "./SettingMessageTemplates.vue?vue&type=script&lang=js"
export * from "./SettingMessageTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports